import { OnInit, Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppTitle } from './title';
import { OneRosterService } from './oneroster.service';
import { Alert } from './alert';
import { SftpRegistration } from './sftp_registration';
import { validateToken } from './account.service';
import { RegistrationFind } from './registration_find';
import { isDateSet, dateFormat } from './date_helper';

@Component({
	selector: 'sftp',
	template: `
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-8 col-md-6 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-6 col-md-6 col-xs-12">
                <alert [alert]="msg" style="display:block;"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-8 col-md-7 col-xs-12">
                <button type="button" class="btn btn-large btn-primary" (click)="connectSftp()">Connect SFTP</button>
                <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="createSftp()">Create SFTP</button>
                <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
            </div>
		    <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="card">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Host</th>
								<th>Username</th>
                                <th>Sync Status</th>
                                <th>Sync Enabled</th>
                                <th>Changed At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of data; let i = index">
                                <td style="width:25%;">{{ row.sftpConfig?.client?.host }}</td>
								<td style="width:20%;">{{ row.sftpConfig?.client?.username }}</td>
                                <td style="width:12%;">{{ row.syncStatus }}</td>
                                <td style="width:10%;">{{ row.syncEnabled }}</td>
                                <td style="width:13%;">{{ printDate(row.updatedAt) ? printDate(row.updatedAt) : printDate(row.createdAt) }}</td>
                                <td style="width:20%;">
                                    <span title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row)">Edit</span> |
                                    <span title="Sync" class="btn-link" style="cursor: pointer;" (click)="sync(row)">Sync</span> |
                                    <span title="School Mapping" class="btn-link" style="cursor: pointer;" (click)="schoolMapping(row)">School Mapping</span> |
                                    <span title="Remove" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="removeSftp(row)"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `
})

export class SftpComponent implements OnInit {
	data: SftpRegistration[];
	msg: Alert;
	msgHead: Alert;
	acctNumber: string;
	hasAccess: boolean;

	constructor(private router: Router, private orvc: OneRosterService, private title: AppTitle, private activatedRoute: ActivatedRoute) {
		this.hasAccess = true;
		this.msg = new Alert();
		this.msgHead = new Alert();
		title.setTitles({
			title: 'SFTP Configurations',
			dashboard: 'SFTP'
		});
		this.title.setBreadcrumbs([
			{ title: 'SFTP', link: `` }
		]);
		this.data = [];
	}

	ngOnInit() {
		this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
		if (this.acctNumber != null) {
			this.orvc.validateAcctNumber(this.acctNumber)
				.subscribe(res => {
					if (!res) {
						this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
						this.hasAccess = false;
					}
				}, err => {
					let e = this.orvc.getUserErrorDefault(err);
					this.msgHead.error(e);
					this.hasAccess = false;
				})
		}
		this.loadData();
	}

	loadData() {
		this.orvc.sftpRegistrationFindApi(this.acctNumber, {})
			.subscribe(res => {
				this.data = res;
				this.msg.close();
			}, err => {
				this.msg.error(this.orvc.getUserErrorDefault(err));
			});
	}

	refresh() {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.loadData();
		this.msg.close();
	}

	connectSftp() {
		this.router.navigate([`settings/${this.acctNumber}/sftp/add`], { queryParams: { mode: 'external' } });
	}

	createSftp() {
		this.router.navigate([`settings/${this.acctNumber}/sftp/add`], { queryParams: { mode: 'hosted' } });
	}

	edit(reg: SftpRegistration) {
		this.router.navigate([`settings/${this.acctNumber}/sftp/${reg.id}/edit`]);
		return;
	}

	sync(reg: SftpRegistration) {
		this.router.navigate([`settings/${this.acctNumber}/sftp/${reg.id}/sync`]);
		return;
	}

	schoolMapping(reg: SftpRegistration) {
		this.router.navigate([`settings/${this.acctNumber}/sftp/${reg.id}/school-mapping`]);
		return;
	}

	removeSftp(reg: SftpRegistration) {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.orvc.sftpRegistrationRemoveApi(this.acctNumber, { id: reg.id })
			.subscribe(res => {
				this.data.splice(this.data.indexOf(reg), 1);
			}, err => {
				let e = this.orvc.getUserErrorDefault(err);
				this.msgHead.error(e);
			});
	}

	printDate(d: Date): string {
		let df = '01/02/2006 03:04 PM';
		if (isDateSet(d)) {
			return dateFormat(d, df);
		}
		return '';
	}
}
